import {
    BrowserEnum,
    SistemaOperacionalEnum
} from '../enums';

export const converterBase64ToArrayBuffer = (base64) => {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }

    return bytes;
};

export const detectarBrowser = () => {
    const { userAgent } = navigator;

    if (userAgent.search('Firefox') >= 0) {
        return userAgent.search('Seamonkey') >= 0 ? BrowserEnum.SEAMONKEY : BrowserEnum.FIREFOX;
    }

    if (userAgent.search('Edge') >= 0) {
        return BrowserEnum.EDGE;
    }

    if (userAgent.search('Opera') >= 0) {
        return BrowserEnum.OPERA;
    }

    if (userAgent.search('MSIE') >= 0 || userAgent.search('Trident') >= 0) {
        return BrowserEnum.INTERNET_EXPLORER;
    }

    if (userAgent.search('Chrome') >= 0) {
        return userAgent.search('Chromium') >= 0 ? BrowserEnum.CHROMIUM : BrowserEnum.CHROME;
    }

    if (userAgent.search('Safari')) {
        return BrowserEnum.SAFARI;
    }

    return BrowserEnum.OUTRO;
};

export const detectarSistemaOperacional = () => {
    const { userAgent } = navigator;

    if (userAgent.search('Windows') >= 0) {
        return userAgent.search('Phone') >= 0 ? SistemaOperacionalEnum.WINDOWS_PHONE : SistemaOperacionalEnum.WINDOWS;
    }

    if (userAgent.search('Mac OS') >= 0) {
        return userAgent.search('Mobile') >= 0 ? SistemaOperacionalEnum.IOS : SistemaOperacionalEnum.MACOS;
    }

    if (userAgent.search('Linux') >= 0) {
        return userAgent.search('Android') >= 0 ? SistemaOperacionalEnum.ANDROID : SistemaOperacionalEnum.LINUX;
    }

    return SistemaOperacionalEnum.OUTRO;
};

export const cpfMask = (value) => {
    return value && value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};

export const cnpjMask = (value) => {
    return value && value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};

export const removeMask = (value) => {
    return value && value
        .replace(/[^A-Za-z0-9 ]/g, '');
};

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');

        if (serializedState === null)
            return undefined;

        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};

export const saveState = (state) => {
    try {
        const serializedState = JSON.stringify(state);

        localStorage.setItem('state', serializedState);
    } catch (error) {
        //Ignore write errors.
        console.log(error);
    }
};